




















import { Component, Vue, Prop } from "vue-property-decorator";
import BookmarkEntry from './BookmarkEntry.vue'
import { walkBookmarks } from '../walk';
import { FrameStore } from "@/modules/base";
import { BookmarkModule, IBookmarkFolder } from "@/modules/BookMarkModule";
import { store } from '@/store';

@Component({
  components: {
    BookmarkEntry,
  },
})
export default class extends Vue {
  @Prop({ required: true })
  module!: FrameStore<typeof BookmarkModule>

  walkAllBookmarks() {
    walkBookmarks(this.module.root, store, this.module)
  }

  stop() {
    this.module.walking = false
  }
}
